<template>
  <div id="login">
    <el-main class="container">
      <div class="login-div">
        <!-- <el-image src="https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg" fit="contain"></el-image> -->
        <div class="form-div">
          <el-button class="scan-div" :style="{'backgroundImage': 'url('+(showType==='login'?scanIcon:loginIcon)+')',
          'border': 'none', 'width': '50px'}" @click="showScanCode" v-show="showType==='login'||showType==='scan'">
            <div class="cover-div"></div>
          </el-button>
          <div class="width-100 content-div" v-show="showType==='login'">
            <el-form ref="loginForm" :model="loginFormData" :rules="loginFormDataRules">
              <el-form-item label="用户名或手机号" prop="userName">
                <el-input v-model="loginFormData.userName" placeholder="请输入用户名或手机号" clearable
                @blur="loginFormData.userName=loginFormData.userName.trim()"></el-input>
              </el-form-item>
              <el-form-item label="密码" prop="password">
                <el-input v-model="loginFormData.password" placeholder="请输入密码" clearable show-password
                @blur="loginFormData.password=loginFormData.password.trim()"></el-input>
              </el-form-item>
            </el-form>
            <el-button type="primary" @click="toLogin">登 录</el-button>
            <div class="link-div">
              <el-link type="primary" @click="forgetPassword">忘记密码？</el-link>
              <el-link type="primary" @click="verificationCode">验证码登录</el-link>
            </div>
          </div>
          <div class="width-100 content-div" v-show="showType==='scan'">
            <div id="code" class="scanCode-div"></div>
          </div>
          <div class="width-100 content-div" v-show="showType==='forget'">
            <el-form ref="forgetForm" :model="forgetFormData" :rules="forgetFormDataRules">
              <el-form-item prop="phoneNo">
                <span slot="label">手机号</span>
                <el-input v-model="forgetFormData.phoneNo" placeholder="请输入手机号" clearable
                @blur="forgetFormData.phoneNo=forgetFormData.phoneNo.trim()"></el-input>
              </el-form-item>
              <el-form-item prop="code">
                <span slot="label">验证码</span>
                <div class="getCode-div">
                  <el-input v-model="forgetFormData.code" placeholder="请输入验证码" clearable maxlength="6" style="width: 50%"
                  @blur="forgetFormData.code=forgetFormData.code.trim()"></el-input>
                  <el-button style="width: 50%" type="primary" @click="getForgetCode" :disabled="forgetDisabled">{{forgetMessage}}</el-button>
                </div>
              </el-form-item>
              <el-form-item prop="password">
                <span slot="label">新密码</span>
                <el-input v-model="forgetFormData.password" placeholder="请输入新密码" clearable show-password
                @blur="forgetFormData.password=forgetFormData.password.trim()"></el-input>
              </el-form-item>
            </el-form>
            <div class="bot-btn-div">
              <el-button @click="goBack">返 回</el-button>
              <el-button type="primary" @click="forgetSubmit">重 置</el-button>
            </div>
          </div>
          <div class="width-100 content-div" v-show="showType==='code'">
            <el-form ref="codeForm" :model="codeFormData" :rules="codeFormDataRules">
              <el-form-item prop="phoneNo">
                <span slot="label">手机号</span>
                <el-input v-model="codeFormData.phoneNo" placeholder="请输入手机号" clearable
                @blur="codeFormData.phoneNo=codeFormData.phoneNo.trim()"></el-input>
              </el-form-item>
              <el-form-item prop="code">
                <span slot="label">验证码</span>
                <div class="getCode-div">
                  <el-input v-model="codeFormData.code" placeholder="请输入验证码" clearable maxlength="6" style="width: 50%"
                  @blur="codeFormData.code=codeFormData.code.trim()"></el-input>
                  <el-button style="width: 50%" type="primary" @click="getVerificationCode" :disabled="codeDisabled">{{codeMessage}}</el-button>
                </div>
              </el-form-item>
            </el-form>
            <div class="bot-btn-div">
              <el-button @click="goBack">返 回</el-button>
              <el-button type="primary" @click="toLogin">登 录</el-button>
            </div>
          </div>
        </div>
      </div>
    </el-main>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data () {
    return {
      scanIcon: require('../../assets/image/ewm.jpg'),
      loginIcon: require('../../assets/image/login.jpg'),
      loginFormData: {
        userName: '',
        password: ''
      },
      loginFormDataRules: {
        userName: [{required: true, message: '请输入用户名或手机号', trigger: 'blur'}],
        password: [{required: true, message: '请输入密码', trigger: 'blur'}]
      },
      forgetFormData: {
        phoneNo: '',
        code: '',
        password: ''
      },
      forgetFormDataRules: {
        phoneNo: [{required: true, message: '请输入手机号', trigger: 'blur'}],
        code: [{required: true, message: '请输入验证码', trigger: 'blur'}],
        password: [{required: true, message: '请输入新密码', trigger: 'blur'}]
      },
      codeFormData: {
        phoneNo: '',
        code: ''
      },
      codeFormDataRules: {
        phoneNo: [{required: true, message: '请输入手机号', trigger: 'blur'}],
        code: [{required: true, message: '请输入验证码', trigger: 'blur'}]
      },
      showType: 'login',
      forgetMessage: '获取验证码',
      forgetDisabled: false,
      codeMessage: '获取验证码',
      codeDisabled: false
    }
  },
  components: {},
  props: {},
  computed: {},
  created () {},
  mounted () {
    // 登录按钮绑定键盘enter事件
    let self = this
    let key = ''
    document.onkeydown = function (e) {
      if (window.event === undefined) {
        key = e.keyCode
      } else {
        key = window.event.keyCode
      }
      if (key === 13) {
        self.toLogin()
      }
    }
    this.checkPassword(null)
  },
  watch: {},
  methods: {
    getFromRequest: function (key) {
      let url = location.search
      let reg = new RegExp('(^|&)' + key + '=([^&]*)(&|$)')
      if (url.indexOf('?') >= 0) {
        let r = url.substr(1).match(reg)
        if (r !== null) {
          return decodeURIComponent(r[2])
        }
      }
      return null
    },
    getSt: function (ssoToken) {
      if (!ssoToken) {
        ssoToken = this.$cookie.readCookie('ssoToken')
      }
      if (!ssoToken) {
        return
      }
      let redirectUrl = this.getFromRequest('redirectUrl')
      let appId = this.getFromRequest('appId')
      if (!redirectUrl || !appId) {
        this.$router.push('/sso')
        return
      }
      this.$axios.post({
        url: '/verify/createSt',
        headers: {
          'ssoToken': ssoToken
        },
        data: {
          redirectUrl: redirectUrl,
          appId: appId
        }
      }).then((res) => {
        let st = res
        setTimeout(() => {
          if (redirectUrl.indexOf('?') > -1) {
            location.href = redirectUrl.substr(0, redirectUrl.indexOf('?') + 1) + 'st=' + st + '&' + redirectUrl.substr(redirectUrl.indexOf('?') + 1)
          } else {
            if (redirectUrl.indexOf('#') > -1) {
              location.href = redirectUrl.substr(0, redirectUrl.indexOf('#')) + '?st=' + st + redirectUrl.substr(redirectUrl.indexOf('#'))
            } else {
              location.href = redirectUrl + '?st=' + st
            }
          }
        }, 500)
      }).catch((err) => {
        console.log('created -> err', err)
      })
    },
    showScanCode: function () {
      if (this.showType === 'login') {
        this.$cookie.createCookie('redirectUrl', location.href)
        this.showType = 'scan'
        window.WwLogin({
          'id': 'code',
          'appid': this.$config.appId,
          'agentid': this.$config.agentid,
          'redirect_uri': this.$config.webviewHost + '/%23/getWxCode',
          'state': '',
          'href': this.$config.wxCssLink
        })
      } else {
        this.showType = 'login'
      }
    },
    toLogin: function () {
      let self = this
      this.$cookie.eraseCookie('ssoToken')
      if (this.showType === 'login') {
        this.$refs['loginForm'].validate(valid => {
          if (valid) {
            this.$axios.post({
              url: '/verify/loginByPwd',
              data: {
                key: this.loginFormData.userName,
                password: this.loginFormData.password
              }
            }).then((res) => {
              self.$cookie.createCookie('ssoToken', res.ssoToken, res.expireTime * 1000)
              self.checkPassword(res.ssoToken)
            }).catch((err) => {
              console.log('created -> err', err)
            })
          }
        })
      } else if (this.showType === 'code') {
        this.$refs['codeForm'].validate(valid => {
          if (valid) {
            this.$axios.post({
              url: '/verify/loginByCode',
              data: {
                mobile: this.codeFormData.phoneNo,
                smsCode: this.codeFormData.code
              }
            }).then((res) => {
              this.$cookie.createCookie('ssoToken', res.ssoToken, res.expireTime * 1000)
              this.checkPassword()
            }).catch((err) => {
              console.log('created -> err', err)
            })
          }
        })
      }
    },
    checkPassword: function (ssoToken) {
      debugger
      if (!ssoToken) {
        ssoToken = this.$cookie.readCookie('ssoToken')
      }
      if (!ssoToken) {
        return
      }
      this.$axios.post({
        url: '/password/needChangePassword',
        headers: {
          'ssoToken': ssoToken
        },
        data: {
        }
      }).then((res) => {
        if (res.needChangePassword) {
          this.$router.push({name: 'ChangePassword', params: {isFirst: res.isFirst, needChangePassword: res.needChangePassword}})
        } else {
          this.getSt(ssoToken)
        }
      }).catch((err) => {
        console.log('created -> err', err)
      })
    },
    forgetPassword: function () {
      this.showType = 'forget'
    },
    verificationCode: function () {
      this.showType = 'code'
    },
    forgetSubmit: function () {
      if (!(/^(?![a-z]+$)(?![A-Z]+$)(?![0-9a-z]+$)(?![0-9A-Z]+$)[0-9A-Za-z]{8,20}$/.test(this.forgetFormData.password))) {
        alert('密码应为8~20位，数字与大小字母的组合，必须同时包含大小写字母。')
        return
      }
      this.$refs['forgetForm'].validate(valid => {
        if (valid) {
          this.$axios.post({
            url: '/verify/updatePwd',
            data: {
              mobile: this.forgetFormData.phoneNo,
              smsCode: this.forgetFormData.code,
              password: this.forgetFormData.password
            }
          }).then((res) => {
            this.$message.success('重置密码成功')
            this.showType = 'login'
          }).catch((err) => {
            console.log('created -> err', err)
          })
        }
      })
    },
    goBack: function () {
      this.showType = 'login'
    },
    getForgetCode: function () {
      this.$cookie.eraseCookie('ssoToken')
      this.$refs['forgetForm'].validateField('phoneNo', errMessage => {
        if (!errMessage) {
          this.$axios.post({
            url: '/verify/createCode',
            data: {
              mobile: this.forgetFormData.phoneNo,
              type: 'UPDATE_PWD'
            }
          }).then((res) => {
            this.$message.success('发送验证码成功')
            let codeResetNum = 60
            this.forgetMessage = codeResetNum + '秒后，重新获取'
            this.forgetDisabled = true
            let forgetCountDownTime = setInterval(() => {
              codeResetNum--
              this.forgetMessage = codeResetNum + '秒后，重新获取'
              if (codeResetNum === 0) {
                this.forgetMessage = '获取验证码'
                this.forgetDisabled = false
                clearInterval(forgetCountDownTime)
              }
            }, 1000)
          }).catch((err) => {
            console.log('created -> err', err)
          })
        }
      })
    },
    getVerificationCode: function () {
      this.$cookie.eraseCookie('ssoToken')
      this.$refs['codeForm'].validateField('phoneNo', errMessage => {
        if (!errMessage) {
          this.$axios.post({
            url: '/verify/createCode',
            data: {
              mobile: this.codeFormData.phoneNo,
              type: 'LOGIN'
            }
          }).then((res) => {
            this.$message.success('发送验证码成功')
            let codeResetNum = 60
            this.codeMessage = codeResetNum + '秒后，重新获取'
            this.codeDisabled = true
            let codeCountDownTime = setInterval(() => {
              codeResetNum--
              this.codeMessage = codeResetNum + '秒后，重新获取'
              if (codeResetNum === 0) {
                this.codeMessage = '获取验证码'
                this.codeDisabled = false
                clearInterval(codeCountDownTime)
              }
            }, 1000)
          }).catch((err) => {
            console.log('created -> err', err)
          })
        }
      })
    }
  }
}
</script>

<style lang='scss' scoped>
.form-div {
  position: relative;
  background: #fff;
  border-radius: 5px;
  border: solid 1px #D8DDE6;
  display: flex;
  flex-direction: column;
  align-items: center;
  .scan-div {
    position: absolute;
    right: 0;
    align-self: flex-end;
    width: 50px;
    height: 50px;
    background-size: 100% 100%;
    .cover-div {
      position: absolute;
      left: 0;
      bottom: 0;
      border-bottom: 45px solid #ffffff;
      border-right: 45px solid transparent;
    }
  }
  .content-div {
    display: flex;
    flex-direction: column;
    align-items: center;
    min-height: 300px;
    .el-form, .el-button, .link-div {
      margin-bottom: 20px;
      width: 90%;
    }
    .el-form {
      margin-top: 20px;
      .el-form-item {
        >>>.el-form-item__label {
          text-align: left;
        }
      }
    }
    .link-div {
      display: flex;
      justify-content: space-between;
      padding: 5px 0px;
      border-top: dashed 1px #D8DDE6;
    }
    .getCode-div {
      display: flex;
      width: 100%;
      .el-button {
        margin-bottom: 0;
      }
    }
    .scanCode-div {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 50px 0px;
      width: 100%;
      background: url('../../assets/image/code.png') no-repeat center ;
      background-size: 100% 100%;
      >>> iframe {
        height: 330px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/login/login.vue